<template>
  <div>
  <!-- Navigation -->
  <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
    <div class="container">
      <!-- <a class="navbar-brand js-scroll-trigger" @click="closeMenu()" href="#">Remember</a> -->
      <button class="navbar-toggler navbar-toggler-right text-uppercase font-weight-bold bg-primary text-white rounded" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
        Menu
        <i class="fas fa-bars"></i>
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item mx-0 mx-lg-1">
            <a class="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger" @click="closeMenu()" href="#">HOME</a>
          </li>
          <li class="nav-item mx-0 mx-lg-1">
            <a class="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger" @click="closeMenu()" href="#about">About</a>
          </li>
         </ul>
      </div>
    </div>
  </nav>

  <!-- Masthead -->
  <header class="masthead bg-primary text-white text-center">
    <div class="container d-flex align-items-center flex-column">
      <!-- <img class="masthead-avatar mt-4 mb-5" src="img/bridge-logo.jpeg" alt=""> -->

    

    </div>


  </header>
  <!-- Masthead Avatar Image -->
    <div id="imgPrincipal" class="d-flex align-items-center flex-column carousel slide" data-interval="4000" data-ride="carousel"> 
        <div class="carousel-inner" >
          <div class="carousel-item active">
            <div class="row">
              <div class="col-12 justify-content-center
              ">
                <!-- <div class="col-6"></div> -->
                <img src="img/bridge-logoCopy.jpeg" class="w-100 image1" alt="..." >  
                <img src="img/logExtendidoBr.png" class="w-100 image2" alt="..." > 
                <!-- <img class="masthead-avatar mt-4 mb-5" src="img/bridge-logoCopy.jpeg" alt=""> -->
              </div>
            </div>
          </div>
          <div class="carousel-item">
              <div class="row">
                <div class="col-12 justify-content-center">
                  <!-- <div class="col-6" ></div> -->
                   <img src="img/WELCOME-KIDS.png" class="w-100 image1" alt="..." >
                   <img src="img/logExtendidoW.png" class="w-100 image2" alt="..." > 
                   <!-- <img class="masthead-avatar mt-4 mb-5" src="img/WELCOME-KIDS.png" alt=""> -->
                </div>
              </div>
          </div>
        </div>
        <a class="carousel-control-prev" href="#imgPrincipal" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#imgPrincipal" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
  <!-- <section>
    <div style="background: red; font-size: 20px;">
      <div id="carouselExampleInterval" class="carousel slide text-white pb-2 pt-2" data-interval="5000" data-ride="carousel">
        <div class="carousel-inner" >
          <div class="carousel-item active">
            <div>
              <span>Stay Home!</span>
            </div>
          </div>
          <div class="carousel-item">
            <div>
              <span>¡Quedate en Casa!</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section> -->

  <!-- Portfolio Section -->
  <section class="page-section portfolio" id="portfolio" style="background-color: white !important; padding-top: 15px;">
    <div class="container">

      <!-- Portfolio Grid Items -->
      <h2 class="text-uppercase text-left text-primary mb-0 mt-3"> Cursos de Ingles </h2>
      <div class="text-left">
        <span>Se dictan clases presenciales en grupos reducidos, agrupados por niveles y para todas las edades se entregar certificación del Instituto Cambridge. </span>
      </div> <br>
      <h2 class="text-uppercase text-left text-primary mb-0 mt-3"> Clase presencial </h2>
      <div class="text-left">
        <span>El aula permite generar la relación interpersonal entre docente-alumno y alumno-alumno, fomentando la motivación y el compromiso necesarios para un exitoso aprendizaje.</span>
      </div> <br>
      <h2 class="text-uppercase text-left text-primary mb-0 mt-3"> Atención </h2>

      <div class="text-left">
        <span>Para informes, inscripciones o cualquier otra consulta enviá un mail a <a href="mailto:bridgeenglishcontact@gmail.com">bridgeenglishcontact@gmail.com</a> </span>
      </div> <br>

      <h2 class="text-uppercase text-left text-primary mb-0 mt-3"> Whatsapp </h2>

      <div class="text-left">
        <span>También podés comunicarte en forma directa.</span>
      </div> <br>

      <div class="row justify-content-center mt-5">

        <div class="col-4">
          <a title="Acceso Alumno" href="/alumnos">
            <img src="img/alumno.png" alt="Acceso Alumno" style="width: 90px;"> 
          </a> 
          <br>
          <b>
            <a href="/alumnos">Acceso <br> Alumnos</a>
          </b>
          <br>
          <span style="font-size: 12px;">Se brinda Información, Notas y Observaciones del Alumno.</span>
        </div>
        <div class="col-4">
          <a title="Acceso Docentes" href="/docentes">
            <img src="img/docente.png" alt="Acceso Docente" style="width: 90px;">
          </a> 
          <br>  
          <b>
            <a href="/docentes">Acceso <br> Docentes</a>
          </b>
          <br>
          <span style="font-size: 12px;">Solo para Docentes y Personal del Instituto.</span>
        </div>

      </div>
    </div>
  </section>

  <!-- About Section -->
  <section class="page-section bg-primary text-white mb-0" id="about">
    <div class="container">

      <!-- About Section Heading -->
      <h2 class="page-section-heading text-center text-uppercase text-white">About</h2> <br>

      <!-- <div class="divider-custom divider-light">
        <div class="divider-custom-line"></div>
        <div class="divider-custom-icon">
          <i class="fas fa-star"></i>
        </div>
        <div class="divider-custom-line"></div>
      </div> -->

      <!-- About Section Content -->
      <div class="row">
        <div class="col-lg-4 ml-auto">
          <p class="lead">
            Bridge School of English es un instituto de Inglés inaugurado en el año 2000. <br>
            Desde entonces se dedica a la enseñanza del idioma brindando a sus alumnos herramientas y posibilidades de crecimiento a nivel personal y profesional.
</p>
        </div>
        <div class="col-lg-4 mr-auto">
          <p class="lead">Contamos con el aval del Instituto Cambridge</p>

          <img src="img/logocambridge.png" alt="" style ="width: 10rem;">
        </div>
      </div>
    </div>
  </section>

  <!-- Contact Section -->


  <!-- Footer -->
  <footer class="footer bg-secondary text-center">
    <div class="container">
      <div class="row justify-content-center">

        <!-- Footer Location -->
        <div class="col-lg-4 mt-3">
          <h4 class="text-uppercase mb-2">Dirección</h4>
          <p class="lead mb-0">Padre Perna 1415
            <br>Garin, Escobar, Buenos Aires</p>
        </div>

        <!-- Footer Location -->
        <div class="col-lg-4 mt-3">
          <h4 class="text-uppercase mb-2">Contacto</h4>
          <p class="lead mb-0">Telefono: 11-3898-5668
            <br>Mail: bridgeenglishcontact@gmail.com</p>
        </div>

      </div>
    </div>
  </footer>

  <!-- Copyright Section -->
  <section class="copyright py-4 text-center text-white">
    <div class="container">
      <small>Copyright &copy; Bridge 2020 - Powered by Matias Maldonado</small>
    </div>
  </section>

  <!-- Scroll to Top Button (Only visible on small and extra-small screen sizes) -->
  <div class="scroll-to-top d-lg-none position-fixed ">
    <a class="js-scroll-trigger d-block text-center text-white rounded" href="#page-top">
      <i class="fa fa-chevron-up"></i>
    </a>
  </div>

  <div class="btn-whatsapp">
    <a href="https://wa.me/541138985668?texto=Hola%20quisiera%20realizar%20una%20consulta" target="_blank">
    <img src="../../public/img/whatsapp.png" alt="">
    </a>
  </div>

</div> 

</template>

<script>

import { mapState, mapActions , mapGetters} from "vuex";

export default {
  name: 'Home',
  data(){
    return {
      tamPantalla: 0,
      mostrar: false,
      link: '',
      contador:0,
      comprar: [],
      nroItem: 1,
      loading: false,
      total: 0,
      contadorbanner: 0,
      provincia: '',
      localidad: '',
      CodigoPostal:'',
      entrega:'',
      envio:0
    }
  },
  methods: {
    ...mapActions(['getProductos','addProductos','delProductos','putProductos','getBanners','getLocalidades']),
    closeMenu(){
      var navbar = $(".navbar-collapse");
      navbar.removeClass('show');
    },
  },
  computed: {
    ...mapState(['productos','ListaLanzamiento','ListaRemeres','ListaTazas','ListaAccesorios','banners','Localidades', 'Provincias'])
  },
  created() {
    console.log('created');
  },
  beforeCreate() {
    console.log('beforeCreate');
  },
  mounted() {
    console.log('mounted');
  },
}
</script>

